import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          common: {
            close: 'Close',
            search: 'Search',
            loading: 'Loading...',
            error: 'Error',
            submit: 'Submit',
            cancel: 'Cancel',
            location: {
              permissionTitle: "Enable Location Services",
              permissionMessage: "Allow us to access your location to find stores near you",
              retryTitle: "Location Access Failed",
              retryMessage: "We couldn't access your location. Please check your settings and try again.",
              blockedTitle: "Location Access Blocked",
              blockedMessage: "Please allow location access in your browser settings to find stores near you",
              errorTitle: "Location Error",
              errorMessage: "Failed to get your location. Please try again or search manually.",
              allow: "Allow",
              retry: "Try Again",
              skip: "Skip",
              warningMessage: "Enable location services to find stores near you",
              enableLocation: "Enable Location",
              autoDetect: "Auto Detect",
              autoDetectDesc: "Use the location system in your device",
              searchManually: "Search Manually",
              searchManuallyDesc: "Search for an address or place",
              searchPlaceholder: "Search for location...",
              getCurrentLocation: "Get Current Location"
            },
            addNew: 'Add New Store',
            recentStores: 'Recently Added Stores',
            searchStores: 'Search recent stores',
            searchLocation: 'Search location or use current location',
            searchHistory: 'Recent Searches',
            clearHistory: 'Clear History',
            storeDetails: {
              name: 'Store Name',
              address: 'Address',
              phone: 'Phone',
              status: 'Status'
            },
            navigation: {
              home: 'Home',
              controlPanel: 'Control Panel',
              login: 'Login',
              logout: 'Logout',
              changeLanguage: 'Change Language',
              technicalSupport: 'Technical Support'
            },
            language: {
              english: 'English',
              arabic: 'Arabic'
            },
            distributor: {
              searchLocation: 'Search location or use current location',
              addStore: 'Add Store',
              recentStores: 'Recently Added Stores',
              searchStores: 'Search stores',
              storeAvailable: 'Store Available',
              storeName: 'Store Name',
              address: 'Address',
              edit: 'Edit',
              delete: 'Delete',
              editStore: 'Edit Store',
              updateStore: 'Update Store',
              addNewStore: 'Add New Store',
              status: 'Status',
              available: 'Available',
              unavailable: 'Unavailable',
              allStores: 'All Stores',
              yourLocation: 'Your Location',
              selectedLocation: 'Selected Location',
              added: 'Added',
              importStores: 'Import Stores',
              exportStores: 'Export Stores',
              exportAllStores: 'Export All Stores',
              exportAvailableStores: 'Export Available Stores',
              exportUnavailableStores: 'Export Unavailable Stores',
              exportByStatus: 'Export by Status',
              exportByCity: 'Export by City',
              importConfirmation: 'Are you sure you want to import {{count}} stores?',
              downloadTemplate: 'Download Template',
              importConfirmationDetailed: 'Import {{count}} stores? ({{available}} available, {{unavailable}} unavailable)',
              filter: 'Filter Stores',
              addedToday: '{{count}} Added Today',
              reports: 'Reports & Analysis',
              statusDistribution: 'Status Distribution',
              totalStores: 'Total Stores',
              weeklyTrend: 'Weekly Trend',
              topCities: 'Top Cities',
              storeMap: 'Store Locations',
              storeActivity: 'Store Addition Activity',
              stores: 'Stores',
              lastWeek: 'Last Week',
              storesAdded: 'Stores Added',
              noData: 'No data available',
              regionMap: 'Store Locations',
              duplicateAddress: 'Store location already registered',
              regions: {
                title: 'Export by Region',
                riyadh: 'Riyadh Region',
                makkah: 'Makkah Region',
                madinah: 'Madinah Region',
                qassim: 'Qassim Region',
                eastern: 'Eastern Region',
                asir: 'Asir Region',
                tabuk: 'Tabuk Region',
                hail: 'Hail Region',
                northern: 'Northern Borders',
                jazan: 'Jazan Region',
                najran: 'Najran Region',
                baha: 'Al-Baha Region',
                jouf: 'Al-Jouf Region'
              },
              cities: {
                riyadh: 'Riyadh',
                jeddah: 'Jeddah',
                makkah: 'Makkah',
                madinah: 'Madinah',
                dammam: 'Dammam',
                khobar: 'Khobar',
                dhahran: 'Dhahran',
                tabuk: 'Tabuk',
                abha: 'Abha',
                taif: 'Taif',
                buraidah: 'Buraidah',
                khamismushait: 'Khamis Mushait'
              },
              location: {
                permissionTitle: "Enable Location Services",
                permissionMessage: "Allow us to access your location to find stores near you",
                retryTitle: "Location Access Failed",
                retryMessage: "We couldn't access your location. Please check your settings and try again.",
                blockedTitle: "Location Access Blocked",
                blockedMessage: "Please allow location access in your browser settings to find stores near you",
                errorTitle: "Location Error",
                errorMessage: "Failed to get your location. Please try again or search manually.",
                allow: "Allow",
                retry: "Try Again",
                skip: "Skip",
                warningMessage: "قم بتفعيل خدمات الموقع او ابحث عن موقع للعثور على المتاجر القريبة منك",
                enableLocation: "تفعيل الموقع",
                autoDetect: "تحديد موقعي تلقائياً",
                autoDetectDesc: "استخدم نظام تحديد المواقع في جهازك",
                searchManually: "إدخال الموقع يدوياً",
                searchManuallyDesc: "البحث عن عنوان أو مكان",
                searchPlaceholder: "ابحث عن موقع...",
                getCurrentLocation: "تحديد موقعي الحالي"
              },
              bulkAdd: 'Bulk Add Stores',
              bulkAddTitle: 'Add Stores in Area',
              selectCity: 'Select City',
              addArea: 'Add Area',
              areaName: 'Area Name',
              verifyStores: 'Verify Stores',
              bulkAddInstructions: "Enter store names under each area. If no area is specified, stores will be added to the selected city.",
              area: "Area",
              actions: "Actions",
              userInput: "Store Name (Input)",
              googleMapName: "Store Name (Google Maps)",
              adding: 'جاري الإضافة...',
              searchResults: 'Search Results',
              showMore: 'Show More',
              allNearbyStoresShown: 'All nearby stores are shown',
              duplicateStores: 'Duplicate Stores',
              duplicatesFound: '{{count}} duplicate stores found',
              duplicateNameWith: 'Duplicate name with {{storeName}}',
              keepingMostRecent: 'Keeping the most recently added store',
              checkDuplicates: 'Check for Duplicates',
              duplicateStoreFound: 'Duplicate store found',
              duplicateStoresDeleted: '{{count}} duplicate stores deleted',
              confirmDeleteDuplicates: 'Delete {{count}} duplicate stores?',
              viewDuplicates: 'View Duplicates',
              noDuplicatesFound: 'No duplicate stores found',
              duplicateAddressFound: 'Store with this address already exists',
              duplicateNameFound: 'Store with this name already exists',
              duplicateLocation: 'Store at this location already exists',
              duplicateDetails: 'Duplicate Details',
              originalStore: 'Original Store',
              duplicateStore: 'Duplicate Store',
              duplicateAddressWith: 'Duplicate address with {{name}}',
              deleteAllDuplicates: 'Delete all duplicate stores',
              nameDuplicate: "Store with name '{{store}}' already exists",
              locationDuplicate: "Store at the same location as '{{store}}' already exists",
              internal_nameDuplicate: "Duplicate name with '{{store}}' in current import",
              internal_locationDuplicate: "Duplicate location with '{{store}}' in current import",
              duplicate: "Duplicate Store",
              duplicateStoresFound: "{{count}} duplicate stores found",
              proceedWithoutDuplicates: "Do you want to proceed with importing non-duplicate stores?",
              verified: "Verified",
              verifying: "جاري التحقق من المتاجر...",
              unverified: "غير متحقق منه",
              approvals: 'Approvals',
              pendingApprovals: 'Pending Approvals',
              deleteRequests: 'Delete Requests',
              noApprovals: 'No pending approvals',
              noDeleteRequests: 'No delete requests',
              approve: 'Approve',
              reject: 'Reject',
              preview: 'Preview',
              approveDelete: 'Approve Delete',
              keepStore: 'Keep Store',
              rejectReason: 'Reason for rejection',
              submittedBy: 'Submitted by',
              requestedBy: 'Requested by',
              pendingStores: 'Pending Stores',
              distributorPortal: 'Distributor Portal',
              submitForApproval: 'Submit for Approval',
              mySubmissions: 'My Submissions',
              searchAndDelete: 'Search & Request Delete',
              submitNewStore: 'Submit New Store',
              yourStats: 'Your Stats',
              pending: 'Pending',
              approved: 'Approved',
              rejected: 'Rejected',
              inDatabase: 'in database',
              noSubmissions: 'No submissions yet',
              requestDeletion: 'Request Deletion',
              deletionReason: 'Reason for deletion',
              submitRequest: 'Submit Request',
              storeSubmitted: 'Store submitted for approval',
              deleteRequestSubmitted: 'Delete request submitted',
              possibleDuplicates: 'Possible duplicates found',
              similarStore: 'Similar store',
              storeAlreadyExists: 'This store already exists!',
              storesMightExist: 'This store might already be added',
              cannotSubmitExactLocation: 'Cannot submit - a store already exists at this exact location',
              allStores: 'All Stores',
              totalStores: 'Total Stores',
              showing: 'Showing',
              stores: 'stores',
              showMore: 'Show More',
              remaining: 'remaining',
              viewOnMap: 'View on Google Maps',
              duplicateReasons: {
                exactLocation: 'Exact location match',
                nearbyLocation: 'Nearby location',
                similarName: 'Similar name'
              },
              approvals: 'Approvals',
              pendingStores: 'Pending Stores',
              deleteRequests: 'Delete Requests',
              noApprovals: 'No pending approvals',
              noDeleteRequests: 'No delete requests',
              preview: 'Preview',
              approve: 'Approve',
              reject: 'Reject',
              approveAll: 'Approve All',
              approveDelete: 'Approve Delete',
              keepStore: 'Keep Store',
              rejectReason: 'Reason for rejection (optional)',
              regions: {
                title: 'Region',
                riyadh: 'Riyadh',
                makkah: 'Makkah',
                madinah: 'Madinah',
                eastern: 'Eastern Province',
                qassim: 'Qassim',
                asir: 'Asir',
                tabuk: 'Tabuk',
                hail: 'Hail',
                northern: 'Northern Borders',
                jazan: 'Jazan',
                najran: 'Najran',
                baha: 'Al Baha',
                jouf: 'Al Jouf'
              }
            },
            auth: {
              login: 'Login',
              register: 'Register',
              registerAsDistributor: 'Register as Distributor',
              fullName: 'Full Name',
              email: 'Email',
              password: 'Password',
              confirmPassword: 'Confirm Password',
              passwordMismatch: 'Passwords do not match',
              weakPassword: 'Password must be at least 6 characters',
              emailInUse: 'This email is already registered',
              invalidEmail: 'Invalid email address',
              userNotFound: 'No account found with this email',
              wrongPassword: 'Incorrect password',
              loginError: 'An error occurred. Please try again.',
              pendingApproval: 'Account Pending Approval',
              pendingApprovalDesc: 'Your account is awaiting admin approval. Please check back later.',
              approveUser: 'Approve User',
              pendingUsers: 'Pending Users',
              noPendingUsers: 'No pending users'
            },
            storeList: {
              availableStores: 'Available Stores',
              phone: 'Phone',
              status: 'Status',
              distance: 'Distance',
              getDirections: 'Get Directions',
              noStores: 'No stores found',
              kmAway: '{{distance}} kilometers away',
              callStore: 'Call Store',
              viewOnMap: 'View on Map',
              viewMore: 'View More Stores',
              veryClose: 'Very Close',
              nearby: 'Nearby',
              moderate: 'Moderate',
              farAway: 'Far',
              calculating: 'Calculating...',
              allNearbyStoresShown: 'All nearby stores are shown'
            },
            errors: {
              locationRequired: 'Location is required',
              addStore: 'Error adding store',
              updateStore: 'Error updating store',
              deleteStore: 'Error deleting store',
              fetchStores: 'Error fetching stores',
              duplicateStore: 'A store with this name already exists',
              duplicateStoresFound: '{{count}} duplicate stores found. Import cancelled.',
              importStores: 'Error importing stores',
              invalidCsvFormat: 'Invalid CSV format. Missing columns: {{columns}}',
              invalidStoreData: '{{count}} stores have invalid data',
              internalDuplicates: '{{count}} duplicate stores found within the import file',
              noStores: "No stores found. Please refresh the page.",
              fetchStores: "Failed to fetch stores. Please refresh the page."
            },
            success: {
              storeAdded: 'Store added successfully',
              storeUpdated: 'Store updated successfully',
              storeDeleted: 'Store deleted successfully',
              deleteRequestSubmitted: 'Delete request submitted',
              storesImported: 'Successfully imported {{count}} stores',
              bulkStoresAdded: 'Successfully added {{count}} stores'
            },
            searchManually: 'البحث يدوياً',
            verified: 'تم التحقق',
            unverified: 'غير متحقق',
            showMore: 'عرض المزيد'
          },
          stores: {
            title: 'Store Locator',
            addNew: 'Add New Store',
            recentlyAdded: 'Recently Added Stores',
            searchPlaceholder: 'Search for stores',
            status: {
              available: 'Available',
              unavailable: 'Unavailable'
            }
          },
          login: {
            title: 'Distributor Login',
            email: 'Email',
            password: 'Password',
            submit: 'Login',
            invalidCredentials: 'Invalid email or password'
          }
        }
      },
      ar: {
        translation: {
          common: {
            close: 'إغلاق',
            search: 'بحث',
            loading: 'جاري التحميل...',
            error: 'خطأ',
            submit: 'إرسال',
            cancel: 'إلغاء',
            location: {
              permissionTitle: "تفعيل خدمات الموقع",
              permissionMessage: "السماح بالوصول إلى موقعك لإيجاد المتاجر القريبة منك",
              retryTitle: "فشل الوصول إلى الموقع",
              retryMessage: "لم نتمكن من الوصول إلى موقعك. يرجى التحقق من الإعدادات والمحاولة مرة أخرى",
              blockedTitle: "تم حظر الوصول إلى الموقع",
              blockedMessage: "يرجى السماح بالوصول إلى موقعك من إعدادات المتصفح للعثور على المتاجر القريبة منك",
              errorTitle: "خطأ في تحديد الموقع",
              errorMessage: "فشل في تحديد موقعك. يرجى المحاولة مرة أخرى أو البحث يدوياً",
              allow: "السماح",
              retry: "حاول مرة أخرى",
              skip: "تخطي",
              warningMessage: "قم بتفعيل خدمات الموقع او ابحث عن موقع للعثور على المتاجر القريبة منك",
              enableLocation: "تفعيل الموقع",
              autoDetect: "تحديد موقعي تلقائياً",
              autoDetectDesc: "استخدم نظام تحديد المواقع في جهازك",
              searchManually: "إدخال الموقع يدوياً",
              searchManuallyDesc: "البحث عن عنوان أو مكان",
              searchPlaceholder: "ابحث عن موقع...",
              getCurrentLocation: "تحديد موقعي الحالي"
            },
            addNew: 'إضافة متجر جديد',
            recentStores: 'المضافة اليوم',
            searchStores: 'البحث في المتاجر الحديثة',
            searchLocation: 'ابحث عن موقع',
            searchHistory: 'عمليات البحث الأخيرة',
            clearHistory: 'مسح السجل',
            storeDetails: {
              name: 'اسم المتجر',
              address: 'العنوان',
              phone: 'رقم الهاتف',
              status: 'الحالة'
            },
            navigation: {
              home: 'الرئيسية',
              controlPanel: 'لوحة التحكم',
              login: 'تسجيل الدخول',
              logout: 'تسجيل الخروج',
              changeLanguage: 'تغيير اللغة',
              technicalSupport: 'الدعم الفني'
            },
            language: {
              english: 'English',
              arabic: 'العربية'
            },
            distributor: {
              searchLocation: 'ابحث عن موقع',
              addStore: 'إضافة متجر',
              recentStores: 'المضافة اليوم',
              searchStores: 'البحث في المتاجر',
              storeAvailable: 'المتجر متاح',
              storeName: 'اسم المتجر',
              address: 'العنوان',
              edit: 'تعديل',
              delete: 'حذف',
              editStore: 'تعديل المتجر',
              updateStore: 'تحديث المتجر',
              addNewStore: 'إضافة متجر جديد',
              status: 'الحالة',
              available: 'متاح',
              unavailable: 'غير متاح',
              allStores: 'جميع المتاجر',
              yourLocation: 'موقعك',
              selectedLocation: 'الموقع المحدد',
              noRecentStores: 'لا يوجد متاجر مضافة حديثاً',
              lastAdded: 'المضافة اليوم',
              added: 'تمت الإضافة',
              importStores: 'استيراد المتاجر',
              exportStores: 'تصدير المتاجر',
              exportAllStores: 'تصدير جميع المتاجر',
              exportAvailableStores: 'تصدير المتاجر المتاحة',
              exportUnavailableStores: 'تصدير المتاجر غير المتاحة',
              exportByStatus: 'تصدير حسب الحالة',
              exportByCity: 'تصدير حسب المدينة',
              importConfirmation: 'هل أنت متأكد من استيراد {{count}} متجر؟',
              downloadTemplate: 'تحميل النموذج',
              importConfirmationDetailed: 'استيراد {{count}} متجر؟ ({{available}} متاح, {{unavailable}} غير متاح)',
              filter: 'تصفية المتاجر',
              addedToday: 'تمت إضافة {{count}} اليوم',
              reports: 'التقارير والتحليلات',
              statusDistribution: 'توزيع الحالة',
              totalStores: 'إجمالي المتاجر',
              weeklyTrend: 'الاتجاه الأسبوعي',
              topCities: 'أعلى المدن',
              storeMap: 'مواقع المتاجر',
              storeActivity: 'نشاط إضافة المتاجر',
              stores: 'متجر',
              lastWeek: 'الأسبوع الماضي',
              storesAdded: 'المتاجر المضافة',
              noData: 'لا توجد بيانات متاحة',
              regionMap: 'مواقع المتاجر',
              duplicateAddress: 'موقع متجر مسجل مسبقاً',
              regions: {
                title: 'تصدير حسب المنطقة',
                riyadh: 'منطقة الرياض',
                makkah: 'منطقة مكة المكرمة',
                madinah: 'منطقة المدينة المنورة',
                qassim: 'منطقة القصيم',
                eastern: 'المنطقة الشرقية',
                asir: 'منطقة عسير',
                tabuk: 'منطقة تبوك',
                hail: 'منطقة حائل',
                northern: 'منطقة الحدود الشمالية',
                jazan: 'منطقة جازان',
                najran: 'منطقة نجران',
                baha: 'منطقة الباحة',
                jouf: 'منطقة الجوف'
              },
              cities: {
                riyadh: 'الرياض',
                jeddah: 'جدة',
                makkah: 'مكة المكرمة',
                madinah: 'المدينة المنورة',
                dammam: 'الدمام',
                khobar: 'الخبر',
                dhahran: 'الظهران',
                tabuk: 'تبوك',
                abha: 'أبها',
                taif: 'الطائف',
                buraidah: 'بريدة',
                khamismushait: 'خميس مشيط'
              },
              location: {
                permissionTitle: "تفعيل خدمات الموقع",
                permissionMessage: "السماح بالوصول إلى موقعك لإيجاد المتاجر القريبة منك",
                retryTitle: "فشل الوصول إلى الموقع",
                retryMessage: "لم نتمكن من الوصول إلى موقعك. يرجى التحقق من الإعدادات والمحاولة مرة أخرى",
                blockedTitle: "تم حظر الوصول إلى الموقع",
                blockedMessage: "يرجى السماح بالوصول إلى موقعك من إعدادات المتصفح للعثور على المتاجر القريبة منك",
                errorTitle: "خطأ في تحديد الموقع",
                errorMessage: "فشل في تحديد موقعك. يرجى المحاولة مرة أخرى أو البحث يدوياً",
                allow: "السماح",
                retry: "حاول مرة أخرى",
                skip: "تخطي",
                warningMessage: "قم بتفعيل خدمات الموقع او ابحث عن موقع للعثور على المتاجر القريبة منك",
                enableLocation: "تفعيل الموقع",
                autoDetect: "تحديد موقعي تلقائياً",
                autoDetectDesc: "استخدم نظام تحديد المواقع في جهازك",
                searchManually: "إدخال الموقع يدوياً",
                searchManuallyDesc: "البحث عن عنوان أو مكان",
                searchPlaceholder: "ابحث عن موقع...",
                getCurrentLocation: "تحديد موقعي الحالي"
              },
              bulkAdd: 'إضافة متاجر متعددة',
              bulkAddTitle: 'إضافة متاجر متعددة في منطقة',
              selectCity: 'اختر المدينة',
              addArea: 'إضافة منطقة',
              areaName: 'اسم المنطقة',
              verifyStores: 'التحقق من المتاجر',
              searchStore: 'البحث عن متجر',
              searchStorePlaceholder: 'ادخل اسم المتجر للبحث',
              viewOnMap: 'عرض على الخريطة',
              searchManually: 'البحث يدوياً',
              bulkAddInstructions: "أدخل أسماء المتاجر تحت كل منطقة. إذا لم يتم تحديد منطقة، ستتم إضافة المتاجر إلى المدينة المحددة.",
              area: "المنطقة",
              actions: "الإجراءات",
              userInput: "الاسم المعطى",
              googleMapName: "الاسم على خرائط جوجل",
              adding: 'جاري الإضافة...',
              searchResults: 'نتائج البحث',
              showMore: 'عرض المزيد',
              allNearbyStoresShown: 'تم عرض جميع المتاجر القريبة',
              duplicateStores: 'المتاجر المكررة',
              duplicatesFound: 'متجر مكرر',
              duplicateNameWith: 'اسم مكرر مع {{storeName}}',
              keepingMostRecent: 'سيتم الاحتفاظ بالمتجر المضاف حديثاً',
              checkDuplicates: 'البحث عن المتاجر المكررة',
              duplicateStoreFound: 'تم العثور على متجر مكرر',
              duplicateStoresDeleted: 'تم حذف {{count}} متجر مكرر',
              confirmDeleteDuplicates: 'هل تريد حذف {{count}} متجر مكرر؟',
              viewDuplicates: 'عرض المتاجر المكررة',
              noDuplicatesFound: 'لم يتم العثور على متاجر مكررة',
              duplicateAddressFound: 'يوجد متجر بهذا العنوان',
              duplicateNameFound: 'يوجد متجر بهذا الاسم',
              duplicateLocation: 'يوجد متجر في هذا الموقع',
              duplicateDetails: 'تفاصيل التكرار',
              originalStore: 'المتجر الأصلي',
              duplicateStore: 'المتجر المكرر',
              duplicateAddressWith: 'عنوان مكرر مع {{name}}',
              deleteAllDuplicates: 'حذف جميع المتاجر المكررة',
              nameDuplicate: "يوجد متجر باسم '{{store}}' مسبقاً",
              locationDuplicate: "يوجد متجر في نفس موقع '{{store}}'",
              internal_nameDuplicate: "اسم مكرر مع '{{store}}' في الملف الحالي",
              internal_locationDuplicate: "موقع مكرر مع '{{store}}' في الملف الحالي",
              duplicate: "متجر مكرر",
              duplicateStoresFound: "تم العثور على {{count}} متجر مكرر",
              proceedWithoutDuplicates: "هل تريد المتابعة باستيراد المتاجر غير المكررة؟",
              verified: "تم التحقق",
              verifying: "جاري التحقق من المتاجر...",
              unverified: "غير متحقق منه",
              approvals: 'الموافقات',
              pendingApprovals: 'الموافقات المعلقة',
              deleteRequests: 'طلبات الحذف',
              noApprovals: 'لا توجد موافقات معلقة',
              noDeleteRequests: 'لا توجد طلبات حذف',
              approve: 'موافقة',
              reject: 'رفض',
              preview: 'معاينة',
              approveDelete: 'الموافقة على الحذف',
              keepStore: 'الاحتفاظ بالمتجر',
              rejectReason: 'سبب الرفض',
              submittedBy: 'مقدم من',
              requestedBy: 'مطلوب من',
              pendingStores: 'المتاجر المعلقة',
              distributorPortal: 'بوابة الموزعين',
              submitForApproval: 'إرسال للموافقة',
              mySubmissions: 'طلباتي',
              searchAndDelete: 'البحث وطلب الحذف',
              submitNewStore: 'إضافة متجر جديد',
              yourStats: 'إحصائياتك',
              pending: 'معلق',
              approved: 'تمت الموافقة',
              rejected: 'مرفوض',
              inDatabase: 'في قاعدة البيانات',
              noSubmissions: 'لا توجد طلبات بعد',
              requestDeletion: 'طلب الحذف',
              deletionReason: 'سبب الحذف',
              submitRequest: 'إرسال الطلب',
              storeSubmitted: 'تم إرسال المتجر للموافقة',
              deleteRequestSubmitted: 'تم إرسال طلب الحذف',
              possibleDuplicates: 'تم العثور على متاجر مشابهة',
              similarStore: 'متجر مشابه',
              storeAlreadyExists: 'هذا المتجر موجود بالفعل!',
              storesMightExist: 'قد يكون هذا المتجر مضافاً مسبقاً',
              cannotSubmitExactLocation: 'لا يمكن الإرسال - يوجد متجر في نفس الموقع بالضبط',
              allStores: 'جميع المتاجر',
              totalStores: 'إجمالي المتاجر',
              showing: 'عرض',
              stores: 'متجر',
              showMore: 'عرض المزيد',
              remaining: 'متبقي',
              viewOnMap: 'عرض على خرائط جوجل',
              duplicateReasons: {
                exactLocation: 'نفس الموقع بالضبط',
                nearbyLocation: 'موقع قريب',
                similarName: 'اسم مشابه'
              },
              approvals: 'الموافقات',
              pendingStores: 'متاجر معلقة',
              deleteRequests: 'طلبات الحذف',
              noApprovals: 'لا توجد موافقات معلقة',
              noDeleteRequests: 'لا توجد طلبات حذف',
              preview: 'معاينة',
              approve: 'موافقة',
              reject: 'رفض',
              approveAll: 'الموافقة على الكل',
              approveDelete: 'الموافقة على الحذف',
              keepStore: 'إبقاء المتجر',
              rejectReason: 'سبب الرفض (اختياري)',
              regions: {
                title: 'المنطقة',
                riyadh: 'الرياض',
                makkah: 'مكة المكرمة',
                madinah: 'المدينة المنورة',
                eastern: 'المنطقة الشرقية',
                qassim: 'القصيم',
                asir: 'عسير',
                tabuk: 'تبوك',
                hail: 'حائل',
                northern: 'الحدود الشمالية',
                jazan: 'جازان',
                najran: 'نجران',
                baha: 'الباحة',
                jouf: 'الجوف'
              },
              submitting: 'جاري الإرسال...',
              submitStores: 'إرسال للموافقة',
              searchExistingStores: 'البحث في المتاجر الحالية',
              searchByNameOrAddress: 'البحث بالاسم أو العنوان...',
              totalStoresInDb: 'إجمالي المتاجر',
              myDeleteRequests: 'طلبات الحذف الخاصة بي',
              noDeleteRequestsYet: 'لا توجد طلبات حذف',
              reason: 'السبب',
              minAgo: 'دقيقة',
              hoursAgo: 'ساعة',
              daysAgo: 'يوم'
            },
            auth: {
              login: 'تسجيل الدخول',
              register: 'تسجيل جديد',
              registerAsDistributor: 'التسجيل كموزع',
              fullName: 'الاسم الكامل',
              email: 'البريد الإلكتروني',
              password: 'كلمة المرور',
              confirmPassword: 'تأكيد كلمة المرور',
              passwordMismatch: 'كلمتا المرور غير متطابقتين',
              weakPassword: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
              emailInUse: 'هذا البريد الإلكتروني مسجل مسبقاً',
              invalidEmail: 'بريد إلكتروني غير صالح',
              userNotFound: 'لا يوجد حساب بهذا البريد الإلكتروني',
              wrongPassword: 'كلمة المرور غير صحيحة',
              loginError: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
              fillAllFields: 'يرجى ملء جميع الحقول',
              distributorPortalDesc: 'أرسل متاجر للموافقة عليها',
              pendingApproval: 'الحساب قيد الموافقة',
              pendingApprovalDesc: 'حسابك في انتظار موافقة المسؤول. يرجى التحقق لاحقاً.',
              approveUser: 'الموافقة على المستخدم',
              pendingUsers: 'المستخدمون المعلقون',
              noPendingUsers: 'لا يوجد مستخدمون معلقون'
            },
            storeList: {
              availableStores: 'المتاجر المتاحة',
              phone: 'رقم الهاتف',
              status: 'الحالة',
              distance: 'المسافة',
              getDirections: 'الاتجاهات',
              noStores: 'لم يتم العثور على متاجر',
              kmAway: 'يبعد {{distance}} كم',
              callStore: 'اتصل بالمتجر',
              viewOnMap: 'عرض على الخريطة',
              viewMore: 'عرض المزيد من المتاجر',
              veryClose: 'قريب جداً',
              nearby: 'قريب',
              moderate: 'متوسط البعد',
              farAway: 'بعيد',
              calculating: 'جاري الحساب...',
              travelTime: 'وقت الرحلة',
              by: {
                car: 'بالسيارة',
                walking: 'مشياً',
                transit: 'بالمواصلات'
              },
              allNearbyStoresShown: 'تم عرض جميع المتاجر القريبة'
            },
            errors: {
              locationRequired: 'الموقع مطلوب',
              addStore: 'خطأ في إضافة المتجر',
              updateStore: 'خطأ في تحديث المتجر',
              deleteStore: 'خطأ في حذف المتجر',
              fetchStores: 'خطأ في جلب المتاجر',
              duplicateStore: 'يوجد متجر بهذا الاسم مسبقاً',
              duplicateStoresFound: 'تم العثور على {{count}} متجر مكرر. تم إلغاء الاستيراد.',
              importStores: 'خطأ في استيراد المتاجر',
              invalidCsvFormat: 'تنسيق CSV غير صالح. الأعمدة المفقودة: {{columns}}',
              invalidStoreData: '{{count}} متجر يحتوي على بيانات غير صالحة',
              internalDuplicates: 'تم العثور على {{count}} متجر مكرر في ملف الاستيراد',
              noStores: "لم يتم العثور على متاجر. يرجى تحديث الصفحة.",
              fetchStores: "فشل في جلب المتاجر. يرجى تحديث الصفحة."
            },
            success: {
              storeAdded: 'تمت إضافة المتجر بنجاح',
              storeUpdated: 'تم تحديث المتجر بنجاح',
              storeDeleted: 'تم حذف المتجر بنجاح',
              deleteRequestSubmitted: 'تم إرسال طلب الحذف',
              storesImported: 'تم استيراد {{count}} متجر بنجاح',
              bulkStoresAdded: 'تمت إضافة {{count}} متجر بنجاح'
            },
            save: 'حفظ',
            searchManually: 'البحث يدوياً',
            verified: 'تم التحقق',
            unverified: 'غير متحقق',
            showMore: 'عرض المزيد'
          },
          stores: {
            title: 'دليل المتاجر',
            addNew: 'إضافة متجر جديد',
            recentlyAdded: 'المضافة حديثاً',
            searchPlaceholder: 'البحث عن المتاجر',
            status: {
              available: 'متاح',
              unavailable: 'غير متاح'
            }
          },
          login: {
            title: 'تسجيل دخول الموزع',
            email: 'البريد الإلكتروني',
            password: 'كلمة المرور',
            submit: 'تسجيل الدخول',
            invalidCredentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة'
          }
        }
      }
    },
    lng: 'ar',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    direction: 'rtl'
  });

export default i18n; 